import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PmContractProjectState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PmContractProjectState = {
  data: [],
  isLoading: false,
  error: null,
};

const PmContractProjectSlice = createSlice({
  name: 'pmContract',
  initialState,
  reducers: {
    setPmContractProjects: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPmContractProjectLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setPmContractProjectError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setPmContractProjects, setPmContractProjectLoading, setPmContractProjectError } =
  PmContractProjectSlice.actions;

export default PmContractProjectSlice.reducer;
